import {Component, OnDestroy, OnInit} from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import {NODE_TYPE, VerifyOptOut} from './verify-opt-out';
import { required } from '../../../../../../../shared/utils';
import { Subscription } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSelect, MatOption } from '@angular/material/select';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

@Component({
    selector: 'app-verify-opt-out',
    templateUrl: './verify-opt-out.component.html',
    styleUrls: ['./verify-opt-out.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, MatSelect, MatOption, CMSComponent, NextSelectorComponent]
})
export class VerifyOptOutComponent extends NodeBuilder implements OnInit, OnDestroy {

  verifyOptOut: VerifyOptOut;
  private channelSubscription: Subscription | null = null;
  showFromNumber = false;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
    this.verifyOptOut = new VerifyOptOut();
  }

  ngOnDestroy(): void {
    if (this.channelSubscription) {
      this.channelSubscription.unsubscribe();
    }
  }

  set buildForm(stepData: any) {
    this.formGroup = this.verifyOptOut.toForm(stepData, this.canEdit);
    this.setAllNextStepValues = ['yes' , 'no', 'error'];

    const initialChannel = this.formGroup.get('channel')?.value;
    this.showFromNumber = initialChannel === 'WHATSAPP';

    this.channelSubscription = this.formGroup.get('channel')?.valueChanges.subscribe(channel => {
      this.showFromNumber = channel === 'WHATSAPP';
      const fromNumberControl = this.formGroup.get('fromNumber');

      if (channel === 'WHATSAPP') {
        fromNumberControl?.setValidators(required('fromNumber'));
      } else {
        fromNumberControl?.clearValidators();
        // Clear value when not visible
        fromNumberControl?.setValue(null);
      }
      fromNumberControl?.updateValueAndValidity();
    });

    // Set initial validators
    if (initialChannel === 'WHATSAPP') {
      this.formGroup.get('fromNumber')?.setValidators(required('fromNumber'));
      this.formGroup.get('fromNumber')?.updateValueAndValidity();
    }
  }

  get getStepData(): {} {
    this.verifyOptOut.setNodeData(this.formGroup.getRawValue());
    return this.verifyOptOut.nodeData;
  }

  get isNodeValid(): boolean {
    return this.isValidateForm();
  }
}
